module.exports = __webpack_public_path__ + "static/media/beef-chicken-original.9c0a32d8.png";